import { defineFcm } from '../shared/factory';

export const FCM_COFFEE_GEO_PROFILE_QUALITY = defineFcm('coffee_geo_profile_quality')
	.asBoolean()
	.withDefault(false)
	.toConfig();
